/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, {
	type RecentMenuWithAnalyticQuery,
} from './__generated__/RecentMenuWithAnalyticQuery.graphql';

type EntryPointParams = { cloudId: string; count: number };

type PreloadedQueries = {
	recentMenuData: RecentMenuWithAnalyticQuery;
};

type SidebarRecentMenuEntryPointComponent = EntryPointComponent<PreloadedQueries, {}, {}, {}>;

export const sidebarRecentMenuEntryPoint: EntryPoint<
	SidebarRecentMenuEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<SidebarRecentMenuEntryPointComponent>(
		/* webpackChunkName: "async-nav4-sidebar-recent-menu" */ './RecentMenuWithAnalytic.tsx',
	),
	getPreloadProps: ({ cloudId, count }: EntryPointParams) => ({
		queries: {
			recentMenuData: {
				parameters,
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				variables: {
					cloudId,
					count,
					keyword: '',
				},
			},
		},
	}),
});
